'use strict';

import TWEEN from '../../../libs/tween.umd';
import {
  autoRotateTimerAction,
  getCurrentCameraDistance, getOrbitControlsCurrentPolarAngle,
  getOrbitControlsDistanceAndPan,
  getPolarAngleFromViewMode,
  getWorldData, setMinAndMaxControlsDistance,
} from '../../controls/orbitControls';
import { Buildings, GSAPAnimationMixer,projectMode, isDesktop, isMobile, settingsData, threeJsVariables } from '../../../settings';
import { animateCamera } from '../../threejs/animation';
import { Box3, Spherical, Vector3 } from 'three';
import { getDelta, userPrevent } from '../../../functions';
import { ViewMode } from '../../../common';
import { BaseElement } from '../../interfaces/BaseElement';
import { CylinderBase } from '../../cylinderGrid/CylinderBase';
import gsap from 'gsap';
import { Lerp } from '../../projectTime/Lerp';

const _spherical = new Spherical();
const _worldPosition = new Vector3();
const _axis = new Vector3(0,-1,0).normalize();

export class Compass {
  static scopes = {};

  constructor (parent,id,camera,controls) {
    this.id = id;
    this.camera = camera;
    this.controls = controls;
    this.vector = new Vector3();
    this.spherical = new Spherical();

    this.element = new BaseElement()
        .addClass('compass-container',isDesktop ? null : 'background-backdrop-filter')
        .appendTo(parent);

    if (this.id === 'orbit' && threeJsVariables.googleMiniMap.params.active && !isMobile) {
      parent.classList.add('--mini-map-position');
    }

    this.btn = new BaseElement('button')
        .addClass('compass', 'icon-compas')
        .addAttribute('data-type','compass')
        .appendTo(this.element.DOMElement)
        .DOMElement;

    Compass.scopes[this.id] = this;
  }

  rotate() {
    this.vector.copy(this.camera.position).sub(this.controls.target);
    this.spherical.setFromVector3(this.vector);
    this.btn.style.transform = `rotate(${this.spherical.theta - config.threejs.compass.correction}rad)`;
  }

  addClickHandler(func) {
    this.btn.addEventListener('click',func);
  }

  addClass(className) {
    this.element.addClass(className);
  }

  visible(state) {
    if (state) {
      this.element.removeClass('hidden');
    } else {
      this.addClass('hidden');
    }
  }

  dispose() {
    this.element.DOMElement.remove();
    this.btn = null;
    this.element = null;
    this.camera = null;
    this.controls = null;
    this.vector = null;
    this.spherical = null;
    delete Compass.scopes[this.id];
  }

  static getScope(id) {
    return Compass.scopes[id];
  }

}

export function compassInit (container = document.body) {
  const compass = new Compass(container,'orbit',threeJsVariables.perspectiveCamera,threeJsVariables.orbitControls);

  if (projectMode.AirMode.active) {
    compass.element.addClass('hidden');
  }

  compass.addClickHandler(compassClickHandler);
  compass.rotate();
}

export function compassClickHandler(arrowObject) {
  if (userPrevent())
    return;

  autoRotateTimerAction('update');

  // const {cameraVector,orbitControlsVector} = getWorldData();
  // const {minAngle,maxAngle} = getPolarAngleFromViewMode();
  // const currentDistance = getCurrentCameraDistance();
  // const currentPolarAngle = getOrbitControlsCurrentPolarAngle();

  // let orbitTarget;

  // if (settingsData.activeViewMode === ViewMode.Orbit){
  //   const defaultOrbitControlsTarget = config.threejs.orbitControls.target;
  //   orbitTarget = new Vector3(defaultOrbitControlsTarget.x,defaultOrbitControlsTarget.y,defaultOrbitControlsTarget.z);
  // } else {
  //   orbitTarget = orbitControlsVector;
  // }

  // let vector;
  // const direction = new Vector3().copy(cameraVector).sub(orbitControlsVector);
  // const compass = Compass.getScope('orbit');

  if (arrowObject.isMesh) {
    arrowObject.getWorldPosition(_worldPosition);
    const arrowDirection = new Vector3().subVectors(_worldPosition,CylinderBase.center);
    _spherical.setFromVector3(arrowDirection);
    // vector = direction.copy(arrowDirection).add(orbitTarget);
  } else {
    // vector = direction.applyAxisAngle(_axis, compass.spherical.theta - config.threejs.compass.correction).add(orbitTarget);
    _spherical.theta = config.threejs.compass.correction;
  }

  // _spherical.setFromVector3(vector);

  const currentTheta = threeJsVariables.orbitControls.getAzimuthalAngle();
  const deltaTheta = getDelta(currentTheta, _spherical.theta);
  const thetaLerp = new Lerp(currentTheta,currentTheta + deltaTheta);

  const progress = {value: 0};

  gsap.to(progress,{
    value: 1,
    ease: GSAPAnimationMixer.ease,
    duration: GSAPAnimationMixer.duration,
    onUpdate: () => threeJsVariables.orbitControls.setAzimuthAngle(thetaLerp.lerp(progress.value))
  });



  // animateCamera(
  //   cameraVector,
  //   vector,
  //   orbitControlsVector,
  //   orbitTarget,
  //   undefined,
  //   currentDistance,
  //   currentPolarAngle,
  //   undefined,
  //   1000,
  //   TWEEN.Easing.Sinusoidal.InOut,
  //   ()=>{
  //     threeJsVariables.orbitControls.maxPolarAngle = currentPolarAngle;
  //     threeJsVariables.orbitControls.minPolarAngle = currentPolarAngle;
  //   },
  //   ()=>{
  //     threeJsVariables.orbitControls.setPolarAngle(currentPolarAngle);
  //     threeJsVariables.orbitControls.maxPolarAngle = maxAngle;
  //     threeJsVariables.orbitControls.minPolarAngle = minAngle;
  //     setMinAndMaxControlsDistance();
  //   }
  // );
}


/**
 * Change compass position in landscape mode when building destroyed
 */

// export const compassPositionChange = (moveDirection) => {
//   return;
//   if (!settingsData.isLandscape) return;
//   const bottomNavBar = document.querySelector('.bottom__nav-bar');
//   const currentDirection = document.documentElement.getAttribute('dir');
//
//   if (currentDirection === 'rtl' && settingsData.buildingDestroyed) {
//     bottomNavBar.style.left = '100px';
//     bottomNavBar.style.right = 'initial';
//   } else if (currentDirection === 'ltr' && settingsData.buildingDestroyed) {
//     bottomNavBar.style.right = '100px';
//     bottomNavBar.style.left = 'initial';
//   } else if (!settingsData.buildingDestroyed) {
//     bottomNavBar.removeAttribute('style');
//     bottomNavBar.style.opacity = '1';
//   }
//
//   // switch (moveDirection) {
//   //   case 'left':
//   //     bottomNavBar.style.left = '100px';
//   //     break;
//   //   case 'right':
//   //     bottomNavBar.style.right = '100px';
//   //     break;
//   //   case 'default':
//   //     bottomNavBar.removeAttribute('style');
//   //     bottomNavBar.style.opacity = '1';
//   //     break;
//   // }
// }

export function compassVisibleToggle (action) {
  const compass = Compass.getScope('orbit');
  if (!compass)
    return;

  switch (action) {
    case 'show':
      compass.visible(true);
      break;
    case 'hide':
      compass.visible(false);
      break;
  }

}
